import Axios from "axios";
import api from "../environment/backend";
const web = api + "portal";
const app = api + "app";

class Requests {
    static login = async (object) => {
        let content;
        await Axios.get(web + "/login", object)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static putNovaSenha = async (object, config, callback) => {
        let content;
        await Axios.put(app + "/alterarSenha", object, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static forgotPass = async (object) => {
        let content;
        await Axios.get(app + "/requerirSenha", object)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static getTecnicos = async (config) => {
        let content;
        await Axios.get(web + "/usuarios/Tecnico", config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static getGestores = async (config) => {
        let content;
        await Axios.get(web + "/usuarios/Gestor", config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static postTecnicos = async (object, config) => {
        let content;
        await Axios.post(web + "/usuarios/Tecnico", object, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static putTecnicos = async (object, config) => {
        let content;
        await Axios.put(web + "/usuarios/Tecnico", object, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static deleteTecnicos = async (object, config) => {
        let content;
        await Axios.delete(web + "/usuarios/" + object.id, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static getRotas = async (config) => {
        let content;
        await Axios.get(web + "/rotas", config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static postRotas = async (object, config) => {
        let content;
        await Axios.post(web + "/rotas", object, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static putRotas = async (object, config) => {
        let content;
        await Axios.put(web + "/rotas", object, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static deleteRotas = async (object, config) => {
        let content;
        await Axios.delete(web + "/rotas/" + object.id, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static getAgenda = async (objeto, config) => {
        let content;
        await Axios.get(web + "/agenda/" + objeto.id_usuario, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };

    static agendarRota = async (objeto, config) => {
        let content;
        await Axios.post(web + "/agenda/" + objeto.id_usuario, objeto, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };

    static changeAgenda = async (objeto, config) => {
        let content;
        await Axios.put(web + "/agenda/" + objeto.id_agenda, objeto, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };

    static deleteAgenda = async (objeto, config) => {
        let content;
        let stringUrl = `${objeto.id_usuario}/${objeto.id_agenda}`;
        await Axios.delete(web + "/agenda/" + stringUrl, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                return err;
            });
        return content;
    };

    static getLocalizacao = async (objeto, config) => {
        let content;
        await Axios.get(web + "/mapa/" + objeto.id, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };

    static getJsons = async (objeto, config) => {
        let content;
        await Axios.post(web + "/jsons", objeto, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };

    static getDetalhes = async (objeto, config) => {
        let content;
        await Axios.get(web + "/mapa/detalhes/" + objeto.id, config)
            .then((res) => {
                const response = res.data;
                content = response;
            })
            .catch((res, err) => {
                console.error(err);
                return err;
            });
        return content;
    };


// ------------- ** REQUISIÇÕES: PAGE REALIZADOS ** ------------------

    static getAllAparelhosAutonomos = async (config) => {
        let content;
        const link = `${web}/realizados/aparelhos`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getRealizadosAparelhosAutonomos = async (config) => {
        let content;
        const link = `${web}/realizados/aparelhos/autonomos`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;

            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //APARELHOS BY ID
    static getRealizadosAparelhosAutonomosById = async (id, config) => {
        let content;
        const link = `${web}/realizados/aparelhos/autonomos/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static putAllDtFinalAparelhos = async (config) => {
        const link = `${web}/realizados/aparelhos`;
        await Axios.put(link, config).then((res) => {
            return res.data;
        }).catch((err) => {
            console.error(err);
        })
    }

    static postDataTrimestralAparelhosAutonomos = async (config) => {
        let content;
        const link = `${web}/realizados/aparelhos`;
        await Axios.post(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllInspFrentTrabalho = async (config) => {
        let content;
        const link = `${web}/realizados/inspecao`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //INSPEÇÃO BY ID
    static getAllInspFrentTrabalhoById = async (id, config) => {
        let content;
        const link = `${web}/realizados/inspecao/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllAnaliseRisco = async (config) => {
        let content;
        const link = `${web}/realizados/analise`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //ANALISE BY ID
    static getAllAnaliseRiscoById = async (id, config) => {
        let content;
        const link = `${web}/realizados/analise/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllMascaraFuga = async (config) => {
        let content;
        const link = `${web}/realizados/mascara`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //MASCARA BY ID
    static getAllMascaraFugaById = async (id, config) => {
        let content;
        const link = `${web}/realizados/mascara/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllDiphoterineBurnfree = async (config) => {
        let content;
        const link = `${web}/realizados/diphoterine`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //DIPHO BY ID
    static getAllDiphoterineBurnfreeById = async (id, config) => {
        let content;
        const link = `${web}/realizados/diphoterine/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllViaturaEmergencia = async (config) => {
        let content;
        const link = `${web}/realizados/viatura`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //VIATURA BY ID
    static getAllViaturaEmergenciaById = async (id, config) => {
        let content;
        const link = `${web}/realizados/viatura/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllBirutas = async (config) => {
        let content;
        const link = `${web}/realizados/birutas`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //BIRUTA BY ID
    static getAllBirutasById = async (id, config) => {
        let content;
        const link = `${web}/realizados/birutas/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllRotas = async (config) => {
        let content;
        const link = `${web}/realizados/rotas`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //ROTAS BY ID
    static getAllRotasById = async (id, config) => {
        let content;
        const link = `${web}/realizados/rotas/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllVeiculos = async (config) => {
        let content;
        const link = `${web}/realizados/veiculos`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //VEICULOS BY ID
    static getAllVeiculosById = async (id, config) => {
        let content;
        const link = `${web}/realizados/veiculos/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllRTC = async (config) => {
        let content;
        const link = `${web}/realizados/rtc`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //RTC BY ID
    static getAllRTCById = async (id, config) => {
        let content;
        const link = `${web}/realizados/rtc/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllSalaBrigada = async (config) => {
        let content;
        const link = `${web}/realizados/sala`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    //SALA BY ID
    static getAllSalaBrigadaById = async (id, config) => {
        let content;
        const link = `${web}/realizados/sala/${id}`;
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    static getAllJustificativasById = async (id, config) => {
        let content;
        const link = `${web}/agenda/justificativa/${id}`;
        // console.log("link", link)
        // console.log("id", id)
        await Axios.get(link, config).then((res) => {
            const response = res.data;
            content = response;
        }).catch((err) => {
            console.error(err);
            return err;
        });
        return content;
    }

    // static getUserNamesByIds = async (ids, config) => {
    //     let content;
    //     const link = `${web}/realizados/viatura/user`;
    //     await Axios.get(link, { params: { ids } , ...config}).then((res) => {
    //         const response = res.data;
    //         content = response;
    //     }).catch((err) => {
    //         console.error(err);
    //         return err;
    //     });
    //     return content;
    // }
}

export default Requests;
